import { ReactElement } from 'react';
import { Card, CardContent } from '@mui/material';
import { DEFAULT_EC2_ROUTES } from '@localstack/constants';
import { useAwsGetter, useRoutes } from '@localstack/services';
import { PageTitle, VPCDetails } from '@localstack/ui';
import { useParams } from 'react-router-dom';

import { EC2Props } from './types';

export const VPC = ({ Layout, clientOverrides, routes = DEFAULT_EC2_ROUTES }: EC2Props): ReactElement => {
  const { goto } = useRoutes();
  const { vpcId } = useParams<'vpcId'>();

  const { data: vpcs } = useAwsGetter('EC2', 'describeVpcs', [{ VpcIds: [vpcId as string] }], {
    clientOverrides,
  });
  const vpc = vpcs?.Vpcs?.[0];

  return (
    <Layout
      documentTitle="EC2: VPC Details"
      title={
        <PageTitle
          title="VPC Details"
          breadcrumbs={[
            ['EC2', () => goto(routes.RESOURCES_EC2)],
            ['VPCs', () => goto(routes.RESOURCES_EC2_VPCS)],
            [vpcId, null],
          ]}
        />
      }
    >
      <Card>
        <CardContent>
          <VPCDetails vpc={vpc} />
        </CardContent>
      </Card>
    </Layout>
  );
};
